import { getRuntimeConfig } from '../runtimeConfig';
import type { LivenessWebhookPayload } from '../types';

export async function submitLivenessWebhook(payload: LivenessWebhookPayload): Promise<void> {
  const config = getRuntimeConfig();
  if (!config.apiBaseUrl) {
    throw new Error('Liveness client is missing apiBaseUrl in runtime-config.js.');
  }

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (config.webhookSecret) {
    headers['x-liveness-webhook-secret'] = config.webhookSecret;
  }

  const response = await fetch(`${trimTrailingSlash(config.apiBaseUrl)}/v1/liveness/webhook`, {
    method: 'POST',
    headers,
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || `Webhook failed with status ${response.status}.`);
  }
}

function trimTrailingSlash(value: string): string {
  return value.replace(/\/$/, '');
}
